<!--
 * @Descripttion: 
 * @version: 图片上传组件
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: hongye
 * @LastEditTime: 2025-05-12 14:58:26
-->
<template>
  <Upload
    name="file"
    listType="picture-card"
    className="avatar-uploader"
    :headers="state.upLoadHeaders"
    :action="state.upLoadUrl"
    :data="{ fileLifeEnum: 'FOREVER', returnUrl: true }"
    :beforeUpload="beforeUpload"
    v-model:file-list="fileList"
    @change="handleChange"
    @preview="handlePreview"
    accept=".png,.jpg,.jpeg"
    :maxCount="maxCount"
  >
    <div v-if="fileList && fileList.length < maxCount">
      <LoadingOutlined v-if="state.loading"></LoadingOutlined>
      <PlusOutlined v-else></PlusOutlined>
      <div class="ant-upload-text">{{ $lang('上传图片') }}</div>
    </div>
  </Upload>
  <Image
    :width="200"
    :style="{ display: 'none' }"
    :preview="{
      visible: imageState.visible,
      onVisibleChange: setVisible
    }"
    :src="imageState.imageUrl"
  />
</template>

<script lang="ts" setup>
  import { reactive, ref, toRefs, watch } from 'vue'
  import { Image, Upload, message } from 'ant-design-vue'
  import { PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue'
  import type { UploadProps } from 'ant-design-vue'
  import { isSuccess } from '@/utils/index'
  import { useAuthStore } from '@/store/auth'
  import { lang } from '@/utils/index'
  const authStore = useAuthStore()
  const { VITE_APP_UPLOAD_URL } = import.meta.env
  const imageState = reactive({
    visible: false,
    imageUrl: ''
  })

  interface Props {
    imageUrl?: { name: string; url: string }[]
    maxCount?: number
    imageSize?: number
  }
  const props = withDefaults(defineProps<Props>(), {
    maxCount: 3,
    imageSize: 10
  })
  const fileList = ref<UploadProps['fileList']>([])
  const emit = defineEmits(['update:value'])

  watch(
    () => props.imageUrl,
    (val) => {
      if (val && val.length) {
        const imageUrl = props?.imageUrl || []
        if (imageUrl.length > props.maxCount) {
          imageUrl.splice(props.maxCount)
        }
        fileList.value = []
        imageUrl.forEach((v, i) => {
          fileList.value?.push({
            uid: `${i}`,
            name: v.name,
            status: 'done',
            url: v.url
          })
        })
      }
    },
    { immediate: true }
  )

  interface StateIn {
    loading: boolean
    upLoadHeaders: { [key: string]: any }
    upLoadUrl: string
  }
  const state: StateIn = reactive({
    loading: false,
    upLoadHeaders: {
      Authtoken: authStore.token,
      sysCode: 'WEB'
    },
    upLoadUrl: VITE_APP_UPLOAD_URL
  })

  const beforeUpload: any = (file: Blob) => {
    return new Promise((resolve) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      const imageSize = props.imageSize
      const isLt2MB = file.size / 1024 / imageSize < 1024
      if (!isJpgOrPng) {
        message.error(lang('只能上传JPG或JPEG或PNG格式文件!'))
        return Upload.LIST_IGNORE
      } else if (!isLt2MB) {
        message.error(lang(`图片大小必须小于${imageSize}MB`) + '!')
        return Upload.LIST_IGNORE
      } else {
        return resolve(true)
      }
    })
  }
  const handleChange = (info: any) => {
    if (info.file.status === 'uploading') {
      state.loading = true
      return
    }
    console.log(info)
    if (info.file.status === 'done') {
      let response = info.file.response
      state.loading = false
      if (!isSuccess(response)) {
        message.error(response.msg || lang('上传出错'))
        info.file.status = 'error'
        return
      }
    }
    if (info.file.status === 'error') {
      state.loading = false
      message.error(lang('上传出错'))
      return
    }
    const str = [] as string[]
    fileList.value?.forEach((v) => {
      if (v?.response && (v.response as any).data?.path) {
        // 上传返回
        str.push((v.response as any).data.path)
      } else if (v.url) {
        // 自定义编辑/回显
        str.push(v.name)
      }
    })
    console.log('str', str)
    emit('update:value', str.join(','))
  }
  /**
   * @description: 预览图片开关
   * @param {*} value
   * @return {*}
   */
  const setVisible = (value: boolean): void => {
    imageState.visible = value
  }
  /**
   * @description: 预览图片
   * @param {*} file
   * @return {*}
   */
  const handlePreview = async (file: any): Promise<any> => {
    if (!file.url && !file.preview) {
      file.preview = (await getBase64(file.originFileObj)) as string
    }
    imageState.imageUrl = file.url || file.preview
    setVisible(true)
  }

  /**
   * @description: 将 File 对象转换为 Base64 编码的字符串
   * @param {File} file - 需要转换为 Base64 编码的 File 对象
   * @return {Promise<string>} - 返回一个 Promise，当转换成功时 resolve Base64 编码的字符串，失败时 reject 错误信息
   */
  const getBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result as string)
      reader.onerror = (error) => reject(error)
    })
  }
</script>
